export const replyTemplates = [
  { value: "insurance", label: "KK-Bestätigung" },
  { value: "timestop", label: "Timestop" },
]

export function replyText(category, firstName = "") {
  const name = String(firstName || "").replace(/[\r\n\t]+/g, " ").trim()
  const greeting = name ? `Hallo ${name}` : "Hallo"
  if (category === "insurance") return `${greeting}

Vielen Dank für deine Anfrage. Du kannst die Abonnementsbestätigung für deine Krankenkasse direkt in der App anfordern. Öffne dazu dein Profil und wähle «KK Bestätigung».

Bitte beachte: Die Bestätigung ist verfügbar, sobald dein Mitgliedschaftsbeitrag bezahlt und auf deinem Mitgliedschaftskonto gutgeschrieben wurde.

Bei weiteren Fragen darfst du dich gerne bei uns melden.`
  if (category === "timestop") return `${greeting}

Vielen Dank für deine Anfrage. Einen Timestop kannst du direkt in der App erfassen.

Öffne dazu dein Profil, wähle «Vertrag» und anschliessend «Abo pausieren». Folge danach den angezeigten Schritten, um deinen Timestop zu erfassen.

Bei Fragen zum Ausfüllen hilft dir unser Team vor Ort gerne weiter.`
  return ""
}
